import api from './api';

// Competition setup — templates, their section trees, and cohort membership.
// Open to super_admin, manager and poc_owner (see get_competition_admin_user).

export const listSetupTemplates = async () => {
  const response = await api.get('/competition-setup/templates');
  return response.data;
};

export const getSetupTemplate = async (templateId) => {
  const response = await api.get(`/competition-setup/templates/${templateId}`);
  return response.data;
};

export const createTemplate = async (payload) => {
  const response = await api.post('/competition-setup/templates', payload);
  return response.data;
};

export const updateTemplate = async (templateId, payload) => {
  const response = await api.patch(`/competition-setup/templates/${templateId}`, payload);
  return response.data;
};

// --- competition details (the student-facing overview page) ----------------
// Open to super_admin, manager and poc_owner, like the rest of this file.
// Everything here is live for students the moment it is saved.

export const getTemplateOverview = async (templateId) => {
  const response = await api.get(`/competition-setup/templates/${templateId}/overview`);
  return response.data;
};

// The whole overview is replaced by what is sent — the editor holds the full
// object, so a partial update would mean guessing which omissions are deletions.
export const saveTemplateOverview = async (templateId, overview) => {
  const response = await api.put(
    `/competition-setup/templates/${templateId}/overview`,
    { overview }
  );
  return response.data;
};

export const uploadTemplateOverviewDoc = async (templateId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post(
    `/competition-setup/templates/${templateId}/overview/upload`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return response.data;
};

export const getTemplateOverviewFileUrl = async (templateId) => {
  const response = await api.get(`/competition-setup/templates/${templateId}/overview/file`);
  return response.data.url;
};

export const createSection = async (templateId, payload) => {
  const response = await api.post(`/competition-setup/templates/${templateId}/sections`, payload);
  return response.data;
};

export const updateSection = async (sectionId, payload) => {
  const response = await api.patch(`/competition-setup/sections/${sectionId}`, payload);
  return response.data;
};

export const deleteSection = async (sectionId) => {
  const response = await api.delete(`/competition-setup/sections/${sectionId}`);
  return response.data;
};

export const getSetupCohort = async (templateId) => {
  const response = await api.get(`/competition-setup/templates/${templateId}/cohort`);
  return response.data;
};

export const withdrawStudent = async (enrollmentId, reason = null) => {
  const response = await api.post(`/competition-setup/enrollments/${enrollmentId}/withdraw`, { reason });
  return response.data;
};

export const reinstateStudent = async (enrollmentId) => {
  const response = await api.post(`/competition-setup/enrollments/${enrollmentId}/reinstate`);
  return response.data;
};
